/* eslint-disable i18next/no-literal-string */
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { alpha } from '@mui/material/styles';
import { useTheme } from '@mui/material';
import GroupsIcon from '@mui/icons-material/Groups';
import SearchIcon from '@mui/icons-material/Search';

const TeamSearchForm = () => {
  const theme = useTheme();

  return (
    <Box
      data-testid="team-search-form"
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: '1fr auto' },
        gap: 3,
        alignItems: 'flex-end',
      }}
    >
      <TextField
        label="Team Name or ID"
        variant="outlined"
        fullWidth
        disabled
        data-testid="team-name-field"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <GroupsIcon
                sx={{
                  color: alpha(theme.palette.primary.main, 0.7),
                }}
                data-testid="team-icon"
              />
            </InputAdornment>
          ),
          sx: {
            borderRadius: {
              xs: 3,
              md: '25px 0 0 25px',
            },
            backgroundColor: alpha(theme.palette.background.paper, 0.5),
            '& fieldset': {
              borderColor: alpha(theme.palette.divider, 0.2),
              borderWidth: '1px',
            },
          },
        }}
      />
      <Button
        variant="contained"
        startIcon={<SearchIcon />}
        disabled
        data-testid="team-search-button"
        sx={{
          borderRadius: {
            xs: 3,
            md: '0 25px 25px 0',
          },
          height: '56px',
          py: 1.7,
          px: 4,
          ml: { xs: 0, md: 0 },
          textTransform: 'none',
          fontWeight: 500,
          fontSize: '0.95rem',
          letterSpacing: '0.02em',
          minWidth: { xs: '100%', md: '120px' },
        }}
      >
        Search
      </Button>
    </Box>
  );
};

export default TeamSearchForm;
